import React, { ReactElement } from 'react';
import { Checkbox } from 'idsk-react-components';
import './ulohyListTable.scss';
import FilterInput from '../../../../FilterInput';
import routes from '../../../../../routing/routes';
import './mojeUlohyPanel.scss';

interface Props {
  searchText: string;
  ibaMojeLegProcesy: boolean;
  setIbaMojeLegProcesy?: (value: boolean) => void;
}

const MojeUlohyPanel = ({
  searchText,
  ibaMojeLegProcesy,
  setIbaMojeLegProcesy,
}: Props): ReactElement => (
  <div className="moje-ulohy-panel">
    <FilterInput
      filterParam={searchText}
      route={routes.mojeUlohy}
      label="Zadajte číslo LP alebo názov"
    />
    <Checkbox
      className="moje-ulohy-checkbox"
      id="ibaMojeLegProcesy"
      checked={ibaMojeLegProcesy}
      onChange={e => setIbaMojeLegProcesy(e.target.checked)}
    >
      Iba moje legislatívne procesy
    </Checkbox>
  </div>
);

export default MojeUlohyPanel;
